<template>
  <div>
    <div class="banner">
      <span>{{$t("about.banner")}}</span>
    </div>
    <div class="section-wrap ">
      <tabnav :tab="tab"></tabnav>
      <div class="tab-content ">

        <div :class="tab==4?'':'hide'">
          <ul class="clearfix tech-ul">
            <li class="tech-li" v-for="item in patent" @click="showLayerBig=true;curImg=item.certificateImage">
              <div>
                <div class="tech-li-img" >
                  <div class="tech-li-img-wrap" :style="{'background-image':'url('+item.certificateImage+'?imageView2/2/w/400/interlace/1)'}"></div>
                </div>
                <div class="tech-li-info">
                  <p class="c-333 cbg-textOver">{{item.mainTitle}}</p>
                  <p class="c-999 cbg-textOver">{{item.subTitle}}</p>
                </div>
                <img src="@/assets/images/public/icon-jing.png" class="abso pc icon-jing">
                <img src="@/assets/images/public/icon-jing-m.png" class="abso mobile icon-jing">
              </div>

            </li>
          </ul>

          <div v-show="patent.length==0" class="tc">
            {{$t("common.date_list")}}
          </div>
          <div class="pagination clearfix" v-show="patent.length>0">
            <a-pagination :class="$i18n.locale" v-model="listQuery.page" :page-size="listQuery.number" :total="listQuery.total" show-less-items @change="sizeChange"/>
          </div>
        </div>
      </div>

    </div>

<div class="layerBig" v-show="showLayerBig">
<div class="bg" @click="showLayerBig=false"></div>
    <div class="abso curImg">
        <img :src="curImg" class="curImg-big " >
        <img src="@/assets/images/public/icon-close.png" class="icon-close abso" @click="showLayerBig=false">
    </div>

</div>
  </div>
</template>

<script>
    import tabnav from './components/tabnav'
    import { selectHonor } from '@api/index'
  import { mapMutations,mapActions } from 'vuex'


  export default {
    name: 'prize',
      components: {tabnav},
    data () {
      return {
          tab:4,
          listQuery:{
              number:12,
              page:1,
              totalPage:1,
              total:18
          },
          curImg:'',
          showLayerBig:false,
          patent:[],


      }
    },
    created () {

    },
      mounted(){
          this.listQuery.languageType = this.$i18n.locale
          this.getList()
      },
    methods: {
        getList() {
            this.$loading.show()
            selectHonor(this.listQuery).then(res=>{
                this.$loading.hide()
                if(res.code==0){
                    this.listQuery.total=res.data.total
                    this.listQuery.totalPage=res.data.totalPage
                    this.patent=res.data.list
                }
            })
        },
        sizeChange(page,size){
            // console.log(page)
            this.listQuery.page=page
            this.getList()
        }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"

  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p{
    margin: 0
  }

  .banner{height:280px;background :url("~@/assets/images/about/banner.jpg") no-repeat center/auto 100%;}
  .tab-nav>div{width:25%;}
    .tab-content{margin-bottom: 1.45rem;}
      .text1{font-size:.16rem;color:#666666;width:6.55rem;margin:0 auto;line-height:.32rem;padding:.43rem 0 .6rem;}

  .video{height:4.4rem;width:100%;display: block; }
  .video{background: url("~@/assets/images/tech/video.png") no-repeat center/cover;border-radius .05rem;}
    .tech-table-w{padding:0 .5rem;padding-bottom 1.2rem;}
    .tech-table{width:100%;background :#f8f8f8;min-height:3rem;}
      .tech-cell{width:50%;vertical-align middle;padding:0.3rem .38rem;position relative;}
.tech-title{font-size:.24rem;}
  .tech-label{font-size:.16rem;padding-bottom .25rem;}
  .tech-text{font-size:.14rem;line-height :.32rem;}
.tech-img1{background: url("~@/assets/images/tech/img1.png") no-repeat center/cover;}
  .tech-img2{background: url("~@/assets/images/tech/img2.png") no-repeat center/cover;}
  .tech-img3{background: url("~@/assets/images/tech/img3.png") no-repeat center/cover;}

    .tech-ul{padding-top:.2rem;}


    .tab1{background:#fff;}
  @media screen and (max-width: 768px){
    .section-wrap{padding:0;}
    .banner{height:3.7rem;background url("~@/assets/images/about/m-banner.jpg") no-repeat center/auto 100%;}
    .tab-content{background:#f8f8f8;margin-bottom: .95rem;}
      .tab1{background:#f8f8f8;}
    .text1{font-size:.26rem;width:86%;line-height:.56rem;padding:.55rem 0 .3rem;}
    .video{border-radius:0;}
    .tech-title{font-size:.32rem;}
    .tech-cell{padding: 0.3rem 0.2rem;}
    .tech-table{background:#fff;min-height :4.66rem;}
    .tech-label{font-size:.24rem;padding-bottom .15rem;}
    .tech-text{font-size:.24rem;line-height .4rem;}
    .tech-table-w{padding:0;margin-top:.55rem;}
    .tech-img1{background: url("~@/assets/images/tech/img1-m.png") no-repeat center/cover;}
    .tech-img2{background: url("~@/assets/images/tech/img2-m.png") no-repeat center/cover;}
    .tech-img3{background: url("~@/assets/images/tech/img3-m.png") no-repeat center/cover;}
    .tech-ul{width:93.33%;margin:0 auto;}

    .pagination{margin-top:.6rem;}
  }
</style>
<style >
  body{background :#f8f8f8}
  </style>
